




















































import {
  defineComponent,
  watch,
  onMounted,
  nextTick,
  useRoute,
  useStore,
  reactive,
} from '@nuxtjs/composition-api'
import { JobOffer, SideJobOffer } from '@/interfaces/db/jobOffer'

interface StoreState {
  user: {
    clientProfile: {
      gender: string
    }
  }
}

interface State {
  limit: number
  jobOffers: (JobOffer | SideJobOffer)[]
  isExistNextList: number | null
  isExistPrevList: number | null
  isFirstOnly: boolean
  isLoaded: boolean
}

export default defineComponent({
  setup() {
    const state = reactive<State>({
        limit: 10,
        jobOffers: [],
        isExistNextList: null,
        isExistPrevList: null,
        isFirstOnly: false,
        isLoaded: true,
      }),
      route = useRoute(),
      store = useStore<StoreState>()

    watch(route, () => reloadFetch())

    onMounted(() => {
      const { gender } = store.state.user.clientProfile
      if (gender) {
        store.commit('SHOW_GLOBAL_NAVI')
      } else {
        store.commit('SHOW_NOT_LOGIN_GLOBAL_NAVI')
      }
      nextTick(async () => {
        reloadFetch()
      })
    })

    const reloadFetch = () => {
      const browserHistoryJobDetails: (JobOffer | SideJobOffer)[] =
        JSON.parse(localStorage.getItem('BrowserHistoryJobDetail') || '{}') || []
      const items: (JobOffer | SideJobOffer)[] = browserHistoryJobDetails || []
      state.jobOffers = items
    }

    const addJobOfferId = (item: JobOffer | SideJobOffer) => {
      const id = item.id
      const tmpItem = item
      // key名変更
      tmpItem.job_offer_id = id
      return tmpItem
    }

    return {
      state,
      reloadFetch,
      addJobOfferId,
    }
  },
})
